/** @jsx jsx */
import {useEffect} from 'preact/hooks'

// Packages
import { jsx } from '@emotion/react'
import { observer } from 'mobx-react-lite'

// CSS
import './quickview.css'

export const QuickView = observer(properties => {

	const props = {
		...properties,
	}

	const {
		open,
		productUrl,
		closeModal,
		productID,
		coreUrl
	} = props

	const fetchAvailability = (variantId) => {
		const variantSectionUrl = `${coreUrl}variants/${variantId}/?section_id=availability`;
		fetch(variantSectionUrl)
			.then(() => {
				const button = document.querySelector(`.pid-${productID} .product-form__submit`);
				button.disabled = false;
				button.name = 'id';
				button.value = variantId;
			})
	}

	const handleError = () => {
			const button = document.querySelector(`.pid-${productID} .product-form__submit`);
			button.disabled = true;
	}

	const handleCloseModal = () => {
		const overlay = document.getElementById('modal-overlay')
		if(overlay) {
			overlay.remove()
		}
		closeModal();
	}

	useEffect(() => {
		document.querySelector('body').addEventListener('click', function(e) {
			if(!document.querySelector('body.modal-open')) return;
			if(!e.target.closest('.quick-view')) {
				handleCloseModal();
			}
		})
	})

	useEffect(() => {
		if(open) {
			document.querySelector('body').classList.add('modal-open');
			fetch(productUrl)
				.then(response => response.text())
				.then(data => {
					document.getElementById('pdp-container-'+productID).innerHTML = data;
					document.querySelector(`.pid-${productID} pickup-availability`).fetchAvailability = fetchAvailability;
					document.querySelector(`.pid-${productID} variant-radios`).handleErrorMessage = handleError;
					document.querySelector(`.pid-${productID} product-form`).handleErrorMessage = handleError;
					const productContent = document.getElementById('product-content-' + productID);
					productContent.replaceWith(document.querySelector(`#pdp-container-${productID} .pdp-default-wrapper`));
					let viewDetails = document.createElement('a');
					viewDetails.href = productUrl;
					viewDetails.innerText = 'View Details →';
					viewDetails.className = 'button button--link-1';
					document.querySelector('.pid-' + productID + ' .product-form__buttons').append(viewDetails);
					const button = document.querySelector(`.pid-${productID} .product-form__submit`);
					button.name = 'id';
					let templateId = document.querySelector('.product-section').id.match(/\d+/)[0];
					document.querySelector(`[name="Size"][form="product-form-template--${templateId}__main"][checked]`).click();
					document.body.insertAdjacentHTML('beforeend', '<div id="modal-overlay"></div>');
					document.querySelectorAll('.thumbnail-list__item.slider__slide button').forEach(t => {
						t.addEventListener('click', (el) => {
							document.querySelector(`.pid-${productID} .product__media img`).srcset = el.currentTarget.children[0].src.replace('300x', '384x');
						});
					})
				})
		} else {
			document.querySelector('body').classList.remove('modal-open');
		}
	}, [open])

	if (!open) return null;

	return (
			<dialog open={open} className={'quick-view modal-container' + (open ? ' open ' : ' ') + 'pid-' + productID}>
					<div className={'pdp-container'} id={'pdp-container-' + productID}></div>
					<div className="modal-header">
						<button className="close-button" onClick={handleCloseModal}>X</button>
					</div>
					<div id={'product-content-' + productID}></div>
			</dialog>
	)
})
